import { SocialLoginButtons } from "@components/SocialLoginButtons";
import { css } from "@emotion/react";
import { useContext, useState } from "react";

import { Button, ButtonTargetKind, ButtonRole } from "src/components/Button";
import { Modal } from "src/components/Modal";
import { EmailSignupForm } from "src/components/Signup/EmailSignupForm";
import { PageSection } from "src/components/layout/PageSection";
import { AuthContext } from "src/context/AuthContext";
import { AuthStatus } from "src/context/AuthContext/types";
import { cssForMediaSize, MediaSize } from "src/theme/mediaQueries";
import { horizontalStackCss, verticalStackCss } from "src/theme/spacing";

function SignupCallsToAction({
  redirectUrl,
  className,
}: {
  className?: string;
  redirectUrl?: string;
}) {
  const [signupOpen, setSignupOpen] = useState(false);

  return (
    <div css={verticalStackCss.s}>
      <Modal
        isOpen={signupOpen}
        onRequestClose={() => setSignupOpen(false)}
        headerText="Sign up"
        showHeader
      >
        <div
          css={cssForMediaSize({
            min: MediaSize.MEDIUM,
            css: css`
              min-width: 412px;
            `,
          })}
        >
          <EmailSignupForm isModal redirectUrl={redirectUrl} />
        </div>
      </Modal>
      <p>Continue with:</p>
      <section
        className={className}
        css={[
          cssForMediaSize({ max: MediaSize.MEDIUM, css: verticalStackCss.m }),
          cssForMediaSize({ min: MediaSize.LARGE, css: horizontalStackCss.m }),
          css`
            width: 100%;
            align-items: center;
          `,
        ]}
      >
        <SocialLoginButtons
          wrapperCss={horizontalStackCss.s}
          redirectUrl={redirectUrl}
        />
        <div css={horizontalStackCss.xs}>
          <Button
            data-tname="signupEmail"
            onClick={{
              kind: ButtonTargetKind.FUNCTION,
              action: () => setSignupOpen(true),
            }}
            role={ButtonRole.TEXT_ONLY}
          >
            Use email instead
          </Button>
        </div>
      </section>
    </div>
  );
}

export const HeaderContent = () => {
  const authState = useContext(AuthContext);
  return (
    <PageSection>
      <div
        css={[
          verticalStackCss.l,
          css`
            max-width: 610px;
          `,
        ]}
      >
        <h1>Donate cryptocurrency to support any charity</h1>
        {authState.status !== AuthStatus.LOGGED_IN && <SignupCallsToAction />}
      </div>
    </PageSection>
  );
};
